import React, { useCallback, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { Container, Grid, Typography } from "@mui/material";
import RtlProvider from '../../../Components/RtlProvider';
import helper from '../../../helper';
import { RHFAutocomplete } from '../../../Components/RHFAutocomplete';
import hotelApi from '../../../api/hotelApi';
import cityApi from '../../../api/cityApi';
import BedCountCircles from '../../../Components/BedCountCircles';
import hotelStructureApi from '../../../api/hotelStructureApi';
import staticVariablesApi from '../../../api/staticVariablesApi';
import Loading from '../../../Components/Loading';
import enumMapper from '../../../enumMapper';


const PlanPanel = () => {
  const [Cities, setCities] = useState([]);
  const [Hotels, setHotels] = useState([]);
  const [hotelStructureIds, setHotelStructureIds] = useState([])
  const [HotelStructure, SetHotelStructure] = useState(null);

  const schema = yup.object().shape({
  });
  const { setValue, handleSubmit, formState: { errors }, control, watch, resetField } = useForm({
    mode: "onChange",
    resolver: yupResolver(schema),
  });
  const hotelStructureId = watch("hotelStructureId")
  const onSubmit = (data) => {
  };
  useEffect(() => {
    GetCityDropDown();
  }, []);
  const handleCityChanged = useCallback(async (id) => {
    resetField("hotelId");
    setHotels(null);

    setHotelStructureIds([]);
    resetField("hotelStructureId")
    SetHotelStructure(null)


    if (id) {
      const hotels = await fetchHotelsByCityConsistency(id);
      setHotels(
        hotels.map((o) => {
          return {
            id: o.key,
            label: o.value
          };
        })
      );
    }
  }, []);
  const handleHotelChanged = useCallback(async (id) => {
    // resetField("");
    setHotelStructureIds([]);
    resetField("hotelStructureId")
    SetHotelStructure(null)

    if (id) {
      const hotelStructureIds = await fetchHotelStrutureDropDown(id);
      const arr = helper.DictionayToList(hotelStructureIds);
      const mappedReponse = arr.map((r) => {
        return {
          id: r.key,
          label: r.value
        };
      });
      setHotelStructureIds(mappedReponse);
      if (arr.length === 1) {
        setValue("hotelStructureId", arr[0].key);

        SetHotelStructure(null);
        const hotelStructure = await fetchHotelStructureById(arr[0].key);
        SetHotelStructure(hotelStructure);

      }

    }
  }, []);


  const GetCityDropDown = () => {
    staticVariablesApi.GetArabicCityConsistencyDropDown()
      .then((res) => {
        const arr = helper.DictionayToList(res.data.data)
        const mappedReponse = arr.map((r) => {
          return {
            id: r.key,
            label: r.value
          };
        });
        setCities(mappedReponse);
      })
      .catch((error) => console.log(error));
  };
  const fetchHotelsByCityConsistency = async (cityConsistency) => {
    try {
      let res = await hotelApi.HotelDropDown(cityConsistency);
      if (res.status == 200) {
      }
      const arr = helper.DictionayToList(res.data.data)
      return arr;
    }
    catch (err) {
      console.error(err);
    }
  };



  const fetchHotelStrutureDropDown = async (hotelId) => {
    try {
      let res = await hotelStructureApi.HotelStrutureDropDown(hotelId);
      if (res.status == 200) {
      }
      return res.data.data;
    }
    catch (err) {
      console.error(err);
    }
  };
  const handleHotelStructureIdChanged = async (id) => {

    // resetField("");
    SetHotelStructure(null);
    if (id) {

      const hotelStructure = await fetchHotelStructureById(id);
      SetHotelStructure(hotelStructure);
    }
  };
  const fetchHotelStructureById = async (id) => {
    try {
      let res = await hotelStructureApi.GetHotelStructure(id);
      if (res.status == 200) {
      }
      return res.data.data;
    }
    catch (err) {
      console.error(err);
    }
  };
  return (
    <Container component="main" maxWidth={false}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <RtlProvider>
          <Typography component="h1" variant="h5" mb={2}>
            جدول تسکین
          </Typography>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={2}>
              <RHFAutocomplete
                loading={!Cities?.length}
                control={control}
                options={Cities ?? []}
                name="CityConsistency"
                placeholder="شهر"
                onChange={handleCityChanged}
                disabled={!Cities?.length}
              />

            </Grid>
            <Grid item xs={12} sm={2}>
              <RHFAutocomplete
                loading={watch("CityConsistency") && !Hotels?.length}
                control={control}
                options={Hotels ?? []}
                name="hotelId"
                placeholder="هتل"
                onChange={handleHotelChanged}
                disabled={!Hotels?.length}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <RHFAutocomplete
                loading={watch("hotelId") && !hotelStructureIds?.length}
                control={control}
                options={hotelStructureIds ?? []}
                name="hotelStructureId"
                placeholder="ساختار"
                onChange={handleHotelStructureIdChanged}
                disabled={!hotelStructureIds?.length || hotelStructureIds?.length === 1}
                style={{
                  border: "none",
                  padding: 0,
                }}
              />
            </Grid>
            <Grid item xs={12}>
              {

                watch("hotelStructureId") ?
                  // hotelStructureId !== undefined && hotelStructureId !== "" && 
                  !HotelStructure ? <Loading /> :
                    (HotelStructure?.hotelFloorDto?.length === 0 ?
                      <p className="error">طبقات این هتل تعریف نشده است</p> :
                      <div style={{ overflowX: 'auto' }}>
                        <table border={1} cellSpacing={0}>
                          <thead style={{ backgroundColor: '#0070c0', color: '#ffffff' }}>
                            <tr>
                              <th>طبقه</th>
                              <th colSpan={HotelStructure?.maxRoomCountOfFloor}>اتاق</th>
                            </tr>
                          </thead>
                          <tbody style={{ textAlign: 'center' }}>
                            {
                              HotelStructure?.hotelFloorDto?.map((row, index) => (
                                <tr key={row.index}>
                                  <th key={row.floorId}>{row.number}</th>
                                  {
                                    row.floorsRoomDto.map((roomdto, i) => (
                                      <td key={roomdto?.roomId} className={helper.RoomTypeBorderColor(roomdto)} style={{ background: roomdto?.roomPlanInfo != null ? roomdto?.roomPlanInfo?.colorCode : "" }}
                                      >
                                        {
                                          <div dir='ltr'>
                                            {roomdto?.roomNumberWithCode}
                                          </div>
                                        }
                                        <div style={{ width: '60px' }}>
                                          <BedCountCircles roomdto={roomdto} />
                                        </div>
                                      </td>

                                    ))
                                  }
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    ) : ""
              }
            </Grid>
          </Grid>
        </RtlProvider>
      </form>
    </Container>
  )
}
export default PlanPanel;